// This file was auto-generated using scripts/generate-icons.js

/**
 * Icon generated from annotate-alt.svg
 *
 * @param {import('preact').JSX.SVGAttributes<SVGSVGElement>} props
 */
export default function AnnotateAltIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      aria-hidden="true"
      {...props}
    >
      <g fill-rule="evenodd" fill="none">
        <path d="M0 0h16v16H0z" />
        <path
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M14 14H2V2h12v12zM2 3a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm12 0a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm0 12a1 1 0 1 1 0-2 1 1 0 0 1 0 2zM2 15a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"
        />
      </g>
    </svg>
  );
}
